import React from 'react';
import '../styles/LegalPages.css';

function DeleteAccount() {
    const email = 'soporte@jamaec.com';
    const subject = 'Eliminar mi cuenta';
    // Plantilla en texto plano (visible y copiable en la página, para que NO
    // dependa de que el dispositivo tenga un cliente de correo configurado).
    const bodyText =
        'Hola equipo de Jama,\n\n' +
        'Solicito la eliminación de mi cuenta y de mis datos personales.\n\n' +
        'Mis datos para identificarme:\n' +
        '- Nombre completo: \n' +
        '- Correo registrado: \n' +
        '- Teléfono registrado: \n' +
        '- Tipo de cuenta (cliente / repartidor / comercio): \n\n' +
        'Gracias.';
    // El botón mailto es solo un atajo; funciona donde haya app de correo.
    const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyText)}`;

    const copy = (text) => {
        try {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text);
                alert('Copiado');
            }
        } catch (e) { /* noop */ }
    };

    return (<div className="legal-page">
        <div className="legal-container">
            <h1>Eliminar tu cuenta de Jama</h1>
            <p className="last-updated">Última actualización: Agosto 2026</p>

            <section className="legal-section">
                <p>
                    En Jama (plataforma operada por <strong>BEEZ CIA LTDA.</strong>, RUC 1091789716001,
                    Ibarra – Ecuador) puedes solicitar la eliminación de tu cuenta y de tus datos personales
                    en cualquier momento. En esta página te explicamos cómo hacerlo y qué información se
                    elimina o se conserva.
                </p>
            </section>

            {/* CÓMO SOLICITARLO */}
            <section className="legal-section">
                <h2>Cómo solicitar la eliminación</h2>
                <p>
                    La eliminación se solicita por correo electrónico. Envía un correo a esta dirección,
                    <strong> identificándote</strong> con tus datos:
                </p>

                {/* Correo de destino (visible y copiable) */}
                <div style={{
                    background: '#FFF4EC', border: '1px solid #F26A1B',
                    borderRadius: '12px', padding: '16px', margin: '16px 0',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    flexWrap: 'wrap', gap: '10px',
                }}>
                    <span style={{ fontSize: '18px', fontWeight: 700, color: '#2A2118', wordBreak: 'break-all' }}>
                        {email}
                    </span>
                    <button
                        type="button"
                        onClick={() => copy(email)}
                        style={{
                            background: '#F26A1B', color: '#fff', border: 'none',
                            fontWeight: 700, padding: '10px 18px', borderRadius: '10px', cursor: 'pointer',
                        }}
                    >
                        Copiar correo
                    </button>
                </div>

                <p>Asunto: <strong>Eliminar mi cuenta</strong>. Incluye en el mensaje:</p>
                <ul>
                    <li>Tu nombre completo.</li>
                    <li>El correo electrónico y/o número de teléfono asociado a tu cuenta de Jama.</li>
                    <li>El tipo de cuenta (cliente, repartidor o comercio).</li>
                </ul>

                <p>Puedes copiar y pegar este texto en tu correo:</p>
                <pre style={{
                    background: '#F6F6F6', border: '1px solid #E2E2E2', borderRadius: '10px',
                    padding: '16px', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                    fontFamily: 'inherit', fontSize: '14px', color: '#2A2118', margin: '10px 0',
                }}>{bodyText}</pre>
                <p style={{ margin: '0 0 20px' }}>
                    <button
                        type="button"
                        onClick={() => copy(bodyText)}
                        style={{
                            background: '#fff', color: '#F26A1B', border: '1px solid #F26A1B',
                            fontWeight: 700, padding: '10px 18px', borderRadius: '10px', cursor: 'pointer',
                        }}
                    >
                        Copiar texto
                    </button>
                    {'  '}
                    <a href={mailto} style={{
                        display: 'inline-block', background: '#F26A1B', color: '#fff',
                        fontWeight: 700, textDecoration: 'none', padding: '11px 18px',
                        borderRadius: '10px', marginLeft: '8px',
                    }}>
                        Abrir en mi app de correo
                    </a>
                </p>

                <p>
                    Con esos datos verificaremos tu identidad para proteger tu cuenta y, una vez confirmada,
                    procesaremos la eliminación de tu cuenta y de tus datos personales.
                </p>
            </section>

            {/* PLAZO */}
            <section className="legal-section">
                <h2>Plazo</h2>
                <p>
                    Confirmaremos la recepción de tu solicitud y eliminaremos tu cuenta y tus datos personales
                    en un plazo máximo de <strong>30 días</strong>, salvo la información que estemos obligados
                    a conservar por ley (ver más abajo).
                </p>
            </section>

            {/* QUÉ DATOS SE ELIMINAN */}
            <section className="legal-section">
                <h2>Qué datos se eliminan</h2>
                <p>Al eliminar tu cuenta se borran o anonimizan de forma permanente, entre otros:</p>
                <ul>
                    <li>Tu perfil: nombre, correo electrónico, teléfono y foto.</li>
                    <li>Tus direcciones guardadas.</li>
                    <li>Tus preferencias y datos de uso asociados a tu cuenta.</li>
                    <li>Los medios de pago guardados (se eliminan de forma segura; Jama no almacena los
                        números completos de tarjeta).</li>
                </ul>
            </section>

            {/* QUÉ SE CONSERVA */}
            <section className="legal-section">
                <h2>Qué información se conserva y por qué</h2>
                <p>
                    Por obligaciones legales, tributarias y de prevención de fraude, es posible que
                    conservemos cierta información durante el plazo que exige la ley, de forma disociada de tu
                    identidad cuando sea posible. Esto incluye, por ejemplo:
                </p>
                <ul>
                    <li>Registros de facturación y transacciones (normativa tributaria del Ecuador).</li>
                    <li>Información necesaria para atender obligaciones legales, contables o de auditoría.</li>
                </ul>
                <p>
                    Transcurridos los plazos legales de conservación, esta información también es eliminada.
                </p>
            </section>

            {/* CONTACTO */}
            <section className="legal-section">
                <h2>Contacto</h2>
                <p>
                    Si tienes dudas sobre la eliminación de tu cuenta o el tratamiento de tus datos, escríbenos
                    a <a href="mailto:soporte@jamaec.com">soporte@jamaec.com</a>. Puedes revisar más detalles
                    en nuestra Política de Privacidad.
                </p>
            </section>
        </div>
    </div>);
}

export default DeleteAccount;
